import api from "./api";
import { ApiResponse } from "./auth.service";
import { EmployerJobPostPayload } from "./types";

export const getLatestJobs = (limit: number = 9): ApiResponse<any> => api.get("/employers/latest-jobs?limit=" + limit).then(res => res.data);

export const postJobs = (payload: EmployerJobPostPayload): ApiResponse<any> => api.post("/employers/jobs", payload).then(res => res.data);
